import { rankingData } from '@/mocks/homeData';

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            热播排行
          </h2>
          <p className="text-foreground-500 text-sm mt-2">本周最受欢迎的影视作品</p>
        </div>

        <div className="bg-background-50 rounded-2xl overflow-hidden">
          {rankingData.map((item, index) => (
            <a
              key={item.id}
              href="#ranking"
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 transition-colors duration-200 cursor-pointer hover:bg-background-100 ${
                index < rankingData.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-black flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-bold text-foreground-900 truncate">{item.title}</span>
                  {item.trend === 'new' && (
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-600 rounded text-[10px] font-semibold whitespace-nowrap">
                      NEW
                    </span>
                  )}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.category}</div>
              </div>

              <div className="text-right flex-shrink-0">
                <div className="text-sm font-black text-primary-600 font-heading">{item.score}</div>
                <div className="text-[10px] text-foreground-400">{item.heat}</div>
              </div>

              <span className="flex-shrink-0 text-foreground-400">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.trend === 'stable' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}